import * as Sentry from '@sentry/react';
import { isSensitiveLocation } from './sentrySanitize';

// Decisão SÍNCRONA no init: carga de página em rota sensível (reset de senha, callback de SSO) = replay
// desligado até o fim desta carga (nunca religa no meio da sessão). Ver `SENSITIVE_ROUTE_PATTERNS`.
export const createReplayIntegrations = (href: string, beforeAddRecordingEvent: (event: any) => any) =>
  isSensitiveLocation(href)
    ? []
    : [
        Sentry.replayIntegration({
          maskAllText: false,
          // explícito: protege contra mudança do default do SDK
          maskAllInputs: true,
          // telas de login/senha (classe `sentry-mask` no container): texto e atributos mascarados
          mask: ['.sentry-mask'],
          beforeAddRecordingEvent,
        }),
      ];

export const stopReplay = () => {
  void Sentry.getReplay()?.stop();
};
